﻿/* eslint-disable no-inner-declarations */
/* eslint-disable-next-line */
import { utils, DOMSanitization } from '../../../Foundation';

export function buildSummary() {
  let debugFunction = false;

  let consoleInfo = 'background: #ECBE13; color: #fff; padding: 4px 10px;';
  let consoleParentTrue =
    'background: #77AB59; color: #fff; padding: 4px 10px;border-left:40px solid white;';
  let consoleChildTrue =
    'background: #77AB59; color: #fff; padding: 4px 10px;border-left:60px solid white;';
  let consoleChildChildTrue =
    'background: #77AB59; color: #fff; padding: 4px 10px;border-left:80px solid white;';
  let consoleParentFalse =
    'background: #E35B5D; color: #fff; padding: 4px 10px;border-left:40px solid white;';
  /* eslint-disable-next-line */
  let consoleChildFalse =
    'background: #E35B5D; color: #fff; padding: 4px 10px;border-left:60px solid white;';
  let consoleChildChildFalse =
    'background: #E35B5D; color: #fff; padding: 4px 10px;border-left:80px solid white;';
  let consoleInteract = 'background: #575A65; color: #fff; padding: 4px 10px;';

  if (debugFunction) {
    console.log('%c ITE buildSummary() Called ', consoleInfo);
  }

  let selectedSide = '';
  let leftSideString = document.querySelector(
    '.configurator__selector__side.configurator__selector__side--left label',
  ).innerHTML;
  let rightSideString = document.querySelector(
    '.configurator__selector__side.configurator__selector__side--right label',
  ).innerHTML;
  let rightSideWidth = '';
  let leftSideWidth = '';

  // ***************
  // Order Type
  // ***************
  let getSide = document.querySelector('.configuratorSide');
  if (typeof getSide != 'undefined' && getSide != null) {
    if (debugFunction) {
      console.log('%c Order type ', consoleParentTrue);
    }
    const selectedSideSelectionLabel = getSide.querySelector('input:checked ~ label');
    if (debugFunction) {
      console.log('%c Side: ' + selectedSideSelectionLabel.innerText, consoleChildTrue);
    }
    // Write to summary
    document.querySelector('.configurator_summary__list-order-type .value').innerHTML =
      selectedSideSelectionLabel.innerText;
    // Write to global variable as well
    selectedSide = selectedSideSelectionLabel.innerText;
    // Heading
    let headings = getSide.querySelectorAll('h2');
    let arrayOfHeadings = Array.from(headings);
    // Find first h2 without an empty string
    let heading = arrayOfHeadings.find((el) => el.innerText.length > 1)
      ? arrayOfHeadings.find((el) => el.innerText.length > 1).innerText
      : null;
    document.querySelector('.configurator_summary__list-order-type .title').innerText = heading;
    // Show summary
    document.querySelector('.configurator_summary__list-order-type').classList.remove('is-hidden');
  }

  // ***************
  // Ear side order
  // ***************
  function switchSides() {
    const sideLeft = document.querySelector('.configurator__selector__side--left').parentNode;
    const sideRight = document.querySelector('.configurator__selector__side--right').parentNode;
    sides.insertBefore(sideRight, sideLeft);
    sides.classList.add('is--visible');
  }

  const sides = document.querySelector('.configuratorSide table tr');
  if (sides) {
    switchSides();
  }

  // ***************
  // Name
  // ***************
  let checkName = document.querySelector('.configurePatientInfo');
  // Question can be hidden rather than not renderred
  let checkNameDisplay = checkNameDisplay ? window.getComputedStyle(checkName).display : null;
  if (typeof checkName != 'undefined' && checkName != null && checkNameDisplay != 'none') {
    if (debugFunction) {
      console.log('%c Name ', consoleParentTrue);
    }

    // Pageload
    let firstName = document.querySelector('[id*="PatientFirstNameTextBox"]');
    let firstNameValue = '';
    let surName = document.querySelector('[id*="PatientLastNameTextBox"]');
    let surNameValue = '';

    // To show or hide summary section
    function showSummary() {
      if (firstNameValue !== '' || surNameValue !== '') {
        document.querySelector('.configurator_summary__list-patient').classList.remove('is-hidden');
        addHeading();
      } else {
        document.querySelector('.configurator_summary__list-patient').classList.add('is-hidden');
      }
    }

    function addHeading() {
      if (debugFunction) {
        console.log('%c addHeading ', consoleChildTrue);
      }
      let headings = checkName.closest('.configurator__section').querySelectorAll('h2, h3');
      let arrayOfHeadings = Array.from(headings);
      // Find first h2 without an empty string
      let heading = arrayOfHeadings.find((el) => el.innerText.length > 1)
        ? arrayOfHeadings.find((el) => el.innerText.length > 1).innerText
        : null;
      document.querySelector('.configurator_summary__list-patient .title').innerText = heading;
    }

    // If the question exists and has a value
    if (typeof firstName != 'undefined' && firstName != null && firstName.value !== '') {
      // Assign its value to the variable
      firstNameValue = firstName.value;
      // Write to summary
      showSummary();
      document.querySelector('.configurator_summary__list-patient .value-first').innerHTML =
        firstNameValue + ' ';
    } else {
      document.querySelector('.configurator_summary__list-patient').classList.add('is-hidden');
    }
    // If the question exists and has a value
    if (typeof surName != 'undefined' && surName != null && firstName && firstName.value !== '') {
      // Assign its value to the variable
      surNameValue = surName.value;
      // Write to summary
      showSummary();
      document.querySelector('.configurator_summary__list-patient .value-second').innerHTML =
        surNameValue;
    } else {
      document.querySelector('.configurator_summary__list-patient').classList.add('is-hidden');
    }
    // Interaction
    // If the user types their name
    if (typeof firstName != 'undefined' && firstName != null) {
      firstName.addEventListener('focusout', () => {
        // Assign its value to the variable
        firstNameValue = firstName.value;
        // Write to summary
        showSummary();
        document.querySelector('.configurator_summary__list-patient .value-first').innerHTML =
          firstNameValue + ' ';
      });
    } else {
      document.querySelector('.configurator_summary__list-patient').classList.add('is-hidden');
    }
    // If the user types their name
    if (typeof surName != 'undefined' && surName != null) {
      surName.addEventListener('focusout', () => {
        // Assign its value to the variable
        surNameValue = surName.value;
        // Write to summary
        showSummary();
        document.querySelector('.configurator_summary__list-patient .value-second').innerHTML =
          surNameValue;
      });
    } else {
      document.querySelector('.configurator_summary__list-patient').classList.add('is-hidden');
    }
  } else {
    if (debugFunction) {
      console.log('%c Name ', consoleParentFalse);
    }
  }

  // ***************
  // Patient Info
  // ***************
  // This area can be a mix of different question types (inputs, selects etc)
  // It can sometimes be hidden via css so we need to check for that
  // Simply loop through all the questions and find any that are not empty on change
  // Add those to an array
  // If the array has length then a question has data
  // Add the heading from the first non empty h2 or h3 in this area
  // Add the data that has been entered
  // Show the summary area on the left
  // If a question is emptied we remove it from the array
  // If all questions are empty we hide the summary area completely
  // We also need to check for data on pageLoad and user interaction
  let getPatientInfo = document.querySelector('.configurePatientInfo');
  // Question can be hidden rather than not renderred
  let getPatientInfoDisplay = getPatientInfoDisplay
    ? window.getComputedStyle(getPatientInfo).display
    : null;
  if (
    typeof getPatientInfo != 'undefined' &&
    getPatientInfo != null &&
    getPatientInfoDisplay != 'none'
  ) {
    if (debugFunction) {
      console.log('%c Patient Info ', consoleParentTrue);
    }

    let questionValues = [];

    function getValues() {
      if (debugFunction) {
        console.log('%c getValues ', consoleChildTrue);
      }
      let questions = getPatientInfo
        .closest('.configurator__section')
        .querySelectorAll('input[type="checkbox"]');
      questions.forEach((question) => {
        let questionValue = question.checked;
        // If question value is not empty and question does not have any options then it is an input
        // If the question does have options it is a select and we need to grab text in different way
        if (questionValue) {
          let inputLabel = question.closest('.configuratorcheckbox')
            ? question.closest('.configuratorcheckbox').querySelector('label').innerText
            : null;
          questionValues.push(inputLabel);
        }
      });
      if (debugFunction) {
        console.table(questionValues);
      }
    }

    function showSummary() {
      if (debugFunction) {
        console.log('%c showSummary ', consoleChildTrue);
      }
      let summaryArea = document.querySelector('.configurator_summary__list-patient');
      if (questionValues.length > 0) {
        summaryArea.classList.remove('is-hidden');
      } else {
        summaryArea.classList.add('is-hidden');
      }
      addHeading();
      addValues(questionValues);
    }

    function addHeading() {
      if (debugFunction) {
        console.log('%c addHeading ', consoleChildTrue);
      }
      let headings = getPatientInfo.closest('.configurator__section').querySelectorAll('h2');
      let arrayOfHeadings = Array.from(headings);
      // Find first h2 without an empty string
      let heading = arrayOfHeadings.find((el) => el.innerText.length > 1)
        ? arrayOfHeadings.find((el) => el.innerText.length > 1).innerText
        : null;
      document.querySelector('.configurator_summary__list-patient .title').innerText = heading;
    }

    function addValues(questionValues) {
      if (debugFunction) {
        console.log('%c addValues ', consoleChildTrue);
      }
      document.querySelector('.configurator_summary__list-patient .value .other').innerHTML = '';
      questionValues.forEach((question) => {
        let html = document.createElement('span');
        html.innerText = question;
        document.querySelector('.configurator_summary__list-patient .value .other').append(html);
      });
    }

    // Pageload
    getValues();
    showSummary();

    // Interaction
    let questionsToWatch = getPatientInfo
      .closest('.configurator__section')
      .querySelectorAll('input[type="checkbox"]');
    questionsToWatch.forEach((question) => {
      question.addEventListener('change', () => {
        questionValues = [];
        getValues();
        showSummary();
      });
    });
  }

  // ***************
  // Audiogram
  // ***************
  let getAudiogram = document.querySelector('#cssConfigureAudiogram');
  // Question can be hidden rather than not renderred
  if (typeof getAudiogram != 'undefined' && getAudiogram != null) {
    if (debugFunction) {
      console.log('%c Audiogram ', consoleParentTrue);
    }

    let questionValuesRight = [];
    let questionValuesRightSum = 0;
    let questionValuesLeft = [];
    let questionValuesLeftSum = 0;

    function getValues() {
      if (debugFunction) {
        console.log('%c getValues ', consoleChildTrue);
      }
      let rightAudiogram = getAudiogram.querySelector('#graphRightEar');
      let rightAudiogramInputs = rightAudiogram
        ? rightAudiogram.querySelector('.audiogram__input').querySelectorAll('input')
        : null;
      if (rightAudiogram) {
        if (debugFunction) {
          console.log('%c Right Side ', consoleChildChildTrue);
        }
        rightAudiogramInputs.forEach((input) => {
          let inputValue = +input.value;
          questionValuesRight.push(inputValue);
        });
      }
      let leftAudiogram = getAudiogram.querySelector('#graphLeftEar');
      let leftAudiogramInputs = leftAudiogram
        ? leftAudiogram.querySelector('.audiogram__input').querySelectorAll('input')
        : null;
      if (leftAudiogram) {
        if (debugFunction) {
          console.log('%c Left Side ', consoleChildChildTrue);
        }
        leftAudiogramInputs.forEach((input) => {
          let inputValue = +input.value;
          questionValuesLeft.push(inputValue);
        });
      }
    }

    function pageLoad() {
      if (debugFunction) {
        console.log('%c pageLoad ', consoleChildTrue);
      }
      getValues();
      showSummary();
    }

    function interaction() {
      if (debugFunction) {
        console.log('%c interaction ', consoleChildTrue);
      }
      let graphs = document.querySelectorAll('.audiogram__graph');
      graphs.forEach((graph) => {
        graph.addEventListener('click', () => {
          if (debugFunction) {
            console.log('%c Graph Clicked ', consoleInteract);
          }
          questionValuesRight = [];
          questionValuesLeft = [];
          getValues();
          showSummary();
        });
      });
      let inputs = document.querySelector('.audiogram__input').querySelectorAll('input');
      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (debugFunction) {
            console.log('%c Input Changed ', consoleInteract);
          }
          questionValuesRight = [];
          questionValuesLeft = [];
          getValues();
          showSummary();
        });
      });
      let buttons = getAudiogram.querySelectorAll('.btn-secondary');
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          if (debugFunction) {
            console.log('%c Button Clicked ', consoleInteract);
          }
          questionValuesRight = [];
          questionValuesLeft = [];
          getValues();
          showSummary();
        });
      });
    }

    function showSummary() {
      if (debugFunction) {
        console.log('%c showSummary ', consoleChildTrue);
      }
      let summaryArea = document.querySelector('.configurator_summary__list-audiogram');

      // If sum is 0 then nothing has been updated on graph
      questionValuesRightSum = questionValuesRight.reduce((partialSum, a) => partialSum + a, 0);
      // If sum is 0 then nothing has been updated on graph
      questionValuesLeftSum = questionValuesLeft.reduce((partialSum, a) => partialSum + a, 0);

      // If either side has been updated show the summary
      if (questionValuesRightSum > 0 || questionValuesLeftSum > 0) {
        if (debugFunction) {
          console.log('%c Show Summary ', consoleChildChildTrue);
        }
        summaryArea.classList.remove('is-hidden');
      } else {
        if (debugFunction) {
          console.log('%c Hide Summary ', consoleChildChildFalse);
        }
        summaryArea.classList.add('is-hidden');
      }
      // Then add the heading and values
      addHeading();
      addValues(questionValuesRight, questionValuesLeft);
    }

    function addHeading() {
      if (debugFunction) {
        console.log('%c addHeading ', consoleChildTrue);
      }
      let headings = getAudiogram.closest('.configurator__section').querySelectorAll('h2, h3');
      let arrayOfHeadings = Array.from(headings);
      // Find first h2 without an empty string
      let heading = arrayOfHeadings.find((el) => el.innerText.length > 1)
        ? arrayOfHeadings.find((el) => el.innerText.length > 1).innerText
        : null;
      document.querySelector('.configurator_summary__list-audiogram .title').innerText = heading;
    }

    function addValues(questionValuesRight, questionValuesLeft) {
      if (debugFunction) {
        console.log('%c addValues ', consoleChildTrue);
      }

      let rightWrapper = document.createElement('span');
      rightWrapper.classList.add('value-right');
      let rightWrapperLabel = document.createElement('span');
      rightWrapperLabel.append(rightSideString);
      rightWrapper.prepend(rightWrapperLabel);

      let leftWrapper = document.createElement('span');
      leftWrapper.classList.add('value-left');
      let leftWrapperLabel = document.createElement('span');
      leftWrapperLabel.append(leftSideString);
      leftWrapper.prepend(leftWrapperLabel);

      if (questionValuesRightSum != 0) {
        if (debugFunction) {
          console.log('%c Right Sum: ' + questionValuesRightSum, consoleChildChildTrue);
        }
        // Empty first and then append
        document.querySelector('.configurator_summary__list-audiogram .value .value-right')
          ? document
              .querySelector('.configurator_summary__list-audiogram .value .value-right')
              .remove()
          : null;
        questionValuesRight.forEach((question) => {
          rightWrapper.append(question + ' ');
          document
            .querySelector('.configurator_summary__list-audiogram .value')
            .append(rightWrapper);
        });
      } else {
        if (debugFunction) {
          console.log('%c Right Sum: ' + questionValuesRightSum, consoleChildChildFalse);
        }
        // Empty as user has reset numbers to 0
        document.querySelector('.configurator_summary__list-audiogram .value .value-right')
          ? document
              .querySelector('.configurator_summary__list-audiogram .value .value-right')
              .remove()
          : null;
      }
      if (questionValuesLeftSum != 0) {
        if (debugFunction) {
          console.log('%c Left Sum: ' + questionValuesLeftSum, consoleChildChildTrue);
        }
        // Empty first and then append
        document.querySelector('.configurator_summary__list-audiogram .value .value-left')
          ? document
              .querySelector('.configurator_summary__list-audiogram .value .value-left')
              .remove()
          : null;
        questionValuesLeft.forEach((question) => {
          leftWrapper.append(question + ' ');
          document
            .querySelector('.configurator_summary__list-audiogram .value')
            .append(leftWrapper);
        });
      } else {
        if (debugFunction) {
          console.log('%c Left Sum: ' + questionValuesLeftSum, consoleChildChildFalse);
        }
        // Empty as user has reset numbers to 0
        document.querySelector('.configurator_summary__list-audiogram .value .value-left')
          ? document
              .querySelector('.configurator_summary__list-audiogram .value .value-left')
              .remove()
          : null;
      }

      // Equalise the width of the side strings (Left and Right for example)
      if (document.querySelector('.configurator_summary__list .value .value-right')) {
        rightSideWidth = document
          .querySelector('.configurator_summary__list .value .Right')
          .getBoundingClientRect().width;
      }
      if (document.querySelector('.configurator_summary__list .value .value-left')) {
        leftSideWidth = document
          .querySelector('.configurator_summary__list .value .Left')
          .getBoundingClientRect().width;
      }
      if (rightSideWidth > leftSideWidth) {
        document
          .querySelectorAll(
            '.configurator_summary__list .value .value-left span, .configurator_summary__list .value .value-right span',
          )
          .forEach((item) => {
            item.setAttribute(
              'style',
              'width:' + rightSideWidth + 'px; text-align:center;display:inline-block;',
            );
          });
      } else if (rightSideWidth < leftSideWidth) {
        document
          .querySelectorAll(
            '.configurator_summary__list .value .value-right span, .configurator_summary__list .value .value-left span',
          )
          .forEach((item) => {
            item.setAttribute(
              'style',
              'width:' + leftSideWidth + 'px; text-align:center;display:inline-block;',
            );
          });
      } else if (rightSideWidth === leftSideWidth) {
        document
          .querySelectorAll(
            '.configurator_summary__list .value .value-right span, .configurator_summary__list .value .value-left span',
          )
          .forEach((item) => {
            item.setAttribute(
              'style',
              'width:' + rightSideWidth + 'px; text-align:center;display:inline-block;',
            );
          });
      }
    }

    // The graphs are added dynamically so we need to detect they have been added and then call needed functions
    /* eslint-disable-next-line */
    let observer = new MutationObserver(function (mutations) {
      if (getAudiogram.querySelector('#graphRightEar, #graphLeftEar')) {
        observer.disconnect();
        pageLoad();
        interaction();
        getValues();
      }
    });
    observer.observe(getAudiogram, {
      attributes: true,
      childList: true,
      characterData: false,
      subtree: true,
    });
  }

  // ***************
  // Earmold
  // ***************

  // The earmolds are added dynamically so we need to detect they have been added first
  /* eslint-disable-next-line */
  let observerEarmold = new MutationObserver(function (mutations) {
    let getEarmoldsMaterial = document.querySelector(
      '.configurator__section__fields__subsection--shell-types',
    );
    if (getEarmoldsMaterial) {
      observerEarmold.disconnect();

      let questionValues = [];

      function getValues() {
        if (debugFunction) {
          console.log('%c getValues ', consoleChildTrue);
        }
        let questions = getEarmoldsMaterial
          ? getEarmoldsMaterial.querySelectorAll(
              'input.configurator__section__fields__subsection--main-model__input',
            )
          : null;
        if (questions && questions.length > 0) {
          questions.forEach((question) => {
            if (question.type == 'radio' && question.checked) {
              let questionValue = question.value;
              questionValues.push(questionValue);
            }
          });
        }
        if (debugFunction) {
          console.table(questionValues);
        }
      }

      function showSummary() {
        if (debugFunction) {
          console.log('%c showSummary ', consoleChildTrue);
        }
        let summaryArea = document.querySelector('.configurator_summary__list-material');
        if (questionValues.length > 0) {
          summaryArea.classList.remove('is-hidden');
        } else {
          summaryArea.classList.add('is-hidden');
        }
        addHeading();
        addValues(questionValues);
      }

      function addHeading() {
        if (debugFunction) {
          console.log('%c addHeading ', consoleChildTrue);
        }
        let headings = getEarmoldsMaterial ? getEarmoldsMaterial.querySelectorAll('h3') : null;
        let arrayOfHeadings = headings ? Array.from(headings) : null;
        // Find first h3 without an empty string
        if (arrayOfHeadings) {
          let heading = arrayOfHeadings.find((el) => el.innerText.length > 1)
            ? arrayOfHeadings.find((el) => el.innerText.length > 1).innerText
            : null;
          document.querySelector('.configurator_summary__list-material .title').innerText = heading;
        }
      }

      function addValues(questionValues) {
        if (debugFunction) {
          console.log('%c addValues ', consoleChildTrue);
        }
        document.querySelector('.configurator_summary__list-material .value').innerHTML = '';
        questionValues.forEach((question) => {
          let html = document.createElement('span');
          html.innerText = question;
          document.querySelector('.configurator_summary__list-material .value').append(html);
        });
      }

      // Pageload
      getValues();
      showSummary();

      // Interaction
      let questionsToWatch = getEarmoldsMaterial
        ? getEarmoldsMaterial.querySelectorAll('input')
        : null;
      if (questionsToWatch) {
        questionsToWatch.forEach((question) => {
          question.addEventListener('change', () => {
            questionValues = [];
            getValues();
            showSummary();
          });
        });
      }
    }
  });
  if (document.querySelector('.configurator-earmold')) {
    observerEarmold.observe(document.querySelector('.configurator-earmold'), {
      attributes: true,
      childList: true,
      characterData: false,
      subtree: true,
    });
  }

  // ***************
  // Everything else
  // ***************
  // Get the value of every other question no matter what
  // We cant reliably target these ones as they dont have a consistent id, class, attr etc
  // Start by ignoring the Patient, Side and Audiogram questions as we are already getting those
  let getConfigurators = document.querySelectorAll(
    '.configurator_controllers .configurator .configurator__section, .configuratorMaterial',
  );
  let specificConfigurators = [...getConfigurators].filter(
    (element) =>
      !element.querySelector(
        '.configurePatientInfo, .configurator__selector__side, #cssConfigureAudiogram',
      ),
  );

  if (typeof specificConfigurators != 'undefined' && specificConfigurators != null) {
    if (debugFunction) {
      console.log('%c Everything else ', consoleParentTrue);
    }

    let values = [];

    function getValues() {
      if (debugFunction) {
        console.log('%c getValues ', consoleChildTrue);
      }
      specificConfigurators.forEach((configurator) => {
        let questions = configurator.querySelectorAll(
          'input.configurator__input, .configuratorcheckbox input, select.configuratordropdown, textarea.configurator__textarea, input.configurator__accessory-checkbox, input.number-input__field',
        );
        let visibleQuestions = [...questions].filter(
          (element) => !element.closest('.configurator__section__fields--disabled'),
        );
        visibleQuestions.forEach((question) => {
          // Inputs
          // And input value is not empty
          if (question.type == 'text' && question.value.length > 0 && question.value != '0') {
            //console.log(question);
            let inputValue = question.value;
            // Charger
            if (question.classList.contains('number-input__field')) {
              inputValue = question
                .closest('.configurator__accessory-inner')
                .querySelector('.configurator__accessory-title')
                ? question.value +
                  ' ' +
                  question
                    .closest('.configurator__accessory-inner')
                    .querySelector('.configurator__accessory-title').innerText
                : null;
            }
            let inputLabel = question.closest('.configurator__section__fields__subsection')
              ? question
                  .closest('.configurator__section__fields__subsection')
                  .querySelector('.configurator__label').innerText
              : null;
            // Charger
            if (question.classList.contains('number-input__field')) {
              inputLabel = question
                .closest('.configurator__section')
                .querySelector('.configurator__accessories-title')
                ? question
                    .closest('.configurator__section')
                    .querySelector('.configurator__accessories-title').innerText
                : null;
            }
            let checkSide = question.closest('.configurator__section__fields')
              ? question
                  .closest('.configurator__section__fields')
                  .classList.contains('configurator__section__fields--right')
              : null;
            let inputSide = '';
            if (
              question
                .closest('.configurator__section')
                .querySelector('.configurator__section__fields--disabled')
            ) {
              inputSide = 'Binaural';
            } else if (
              question.closest('.configurator__section__monoBorder') ||
              question.closest('[id*="mono_"]')
            ) {
              inputSide = null;
            } else {
              if (question.closest('.configurator__section__fields')) {
                // Right side
                if (checkSide) {
                  inputSide = 'Right';
                } else {
                  inputSide = 'Left';
                }
              } else if (question.closest('.configurator__section__monoBorder')) {
                inputSide = null;
              }
            }
            //console.log(question.type);
            //console.log(inputLabel + ': ' + inputValue + ' - ' + inputSide);
            values.push({ inputLabel, inputSide, inputValue });
          }

          if (question.type == 'radio' && question.checked) {
            //console.log(question);
            let inputValue = question.value;
            // If inside color dropdown we need to get translated text rather than value
            if (question.closest('color-dropdown')) {
              inputValue = question
                .closest('.configurator__section__color')
                .querySelector('label').innerText;
            }
            let inputLabel = question.closest('.configurator__panel')
              ? question
                  .closest('.configurator__panel')
                  .querySelector('.configurator__section__headline').innerText
              : null;
            let checkSide = question.closest('.configurator__section__fields')
              ? question
                  .closest('.configurator__section__fields')
                  .classList.contains('configurator__section__fields--right')
              : null;
            let inputSide = '';
            if (
              question
                .closest('.configurator__section')
                .querySelector('.configurator__section__fields--disabled')
            ) {
              inputSide = 'Binaural';
            } else {
              // Right side
              if (checkSide) {
                inputSide = 'Right';
              } else {
                inputSide = 'Left';
              }
            }
            //console.log(question.type);
            //console.log(inputLabel + ': ' + inputValue + ' - ' + inputSide);
            values.push({ inputLabel, inputSide, inputValue });
          }

          if (question.type == 'checkbox' && question.checked) {
            //console.log(question);
            let inputValue = '&#x2713;';
            // Charger
            if (question.classList.contains('configurator__accessory-checkbox')) {
              inputValue = question
                .closest('.configurator__accessory-inner')
                .querySelector('.configurator__accessory-title')
                ? question
                    .closest('.configurator__accessory-inner')
                    .querySelector('.configurator__accessory-title').innerText
                : null;
            }
            let inputLabel = question.closest('.configuratorcheckbox')
              ? question.closest('.configuratorcheckbox').querySelector('label').innerText
              : null;
            // Charger
            if (question.classList.contains('configurator__accessory-checkbox')) {
              inputLabel = question
                .closest('.configurator__section')
                .querySelector('.configurator__accessories-title')
                ? question
                    .closest('.configurator__section')
                    .querySelector('.configurator__accessories-title').innerText
                : null;
            }
            let checkSide = question.closest('.configurator__section__fields')
              ? question
                  .closest('.configurator__section__fields')
                  .classList.contains('configurator__section__fields--right')
              : null;
            let inputSide = '';
            if (
              question
                .closest('.configurator__section')
                .querySelector('.configurator__section__fields--disabled')
            ) {
              inputSide = 'Binaural';
            } else if (
              question.closest('.configurator__section__monoBorder') ||
              question.closest('[id*="mono_"]')
            ) {
              inputSide = null;
            } else {
              // Right side
              if (checkSide) {
                inputSide = 'Right';
              } else {
                inputSide = 'Left';
              }
            }
            //console.log(question.type);
            //console.log(inputLabel + ': ' + inputValue + ' - ' + inputSide);
            values.push({ inputLabel, inputSide, inputValue });
          }

          // Selects
          // And select index is not first item (sometimes this just says select so we dont want to grab it)
          if (
            (question.selectedIndex != -1 &&
              question.options &&
              question.options[question.selectedIndex].index > 0) ||
            (question.options && question.options.length == 1)
          ) {
            //console.log(question);
            let inputValue = question.options[question.selectedIndex].text;
            let inputLabel = question.closest('.configurator__section__fields__subsection')
              ? question
                  .closest('.configurator__section__fields__subsection')
                  .querySelector('.configurator__label').innerText
              : null;
            let checkSide = question.closest('.configurator__section__fields')
              ? question
                  .closest('.configurator__section__fields')
                  .classList.contains('configurator__section__fields--right')
              : null;
            let inputSide = '';
            if (
              question
                .closest('.configurator__section')
                .querySelector('.configurator__section__fields--disabled')
            ) {
              inputSide = 'Binaural';
            } else {
              if (question.closest('.configurator__section__fields')) {
                // Right side
                if (checkSide) {
                  inputSide = 'Right';
                } else {
                  inputSide = 'Left';
                }
              } else if (question.closest('.configurator__section__monoBorder')) {
                inputSide = 'Binaural';
              }
            }
            //console.log(question.type);
            //console.log(inputLabel + ': ' + inputValue + ' - ' + inputSide);
            values.push({ inputLabel, inputSide, inputValue });
          }

          // Textarea
          if (question.type == 'textarea' && question.value.length > 0) {
            //console.log(question);
            let inputValue = '&#x2713;';
            let inputLabel = question.closest('.configurator__section__fields__subsection')
              ? question
                  .closest('.configurator__section__fields__subsection')
                  .querySelector('.configurator__label').innerText
              : null;
            let checkSide = question.closest('.configurator__section__fields')
              ? question
                  .closest('.configurator__section__fields')
                  .classList.contains('configurator__section__fields--right')
              : null;
            let inputSide = '';
            if (
              question
                .closest('.configurator__section')
                .querySelector('.configurator__section__fields--disabled')
            ) {
              inputSide = 'Binaural';
            } else {
              // Right side
              if (checkSide) {
                inputSide = 'Right';
              } else {
                inputSide = 'Left';
              }
            }
            //console.log(question.type);
            //console.log(inputLabel + ': ' + inputValue + ' - ' + inputSide);
            values.push({ inputLabel, inputSide, inputValue });
          }
        });
      });

      if (debugFunction) {
        console.table(values);
      }
      //let sortedAlpha = values.sort((a, b) => a.inputLabel.localeCompare(b.inputLabel));
      //console.table(sortedAlpha);
    }

    function pageLoad() {
      if (debugFunction) {
        console.log('%c pageLoad ', consoleChildTrue);
      }
      values = [];
      getValues();
      showSummary();
    }

    function interaction() {
      if (debugFunction) {
        console.log('%c interaction ', consoleChildTrue);
      }
      specificConfigurators.forEach((configurator) => {
        configurator.addEventListener('click', () => {
          values = [];
          getValues();
          showSummary();
        });
        configurator.addEventListener('change', () => {
          values = [];
          getValues();
          showSummary();
        });
      });
    }

    function showSummary() {
      if (debugFunction) {
        console.log('%c showSummary ', consoleChildTrue);
      }
      let summaryArea = document.querySelector('.configurator_summary__list-everything');

      // If either side has been updated show the summary
      if (values.length) {
        if (debugFunction) {
          console.log('%c Show Summary ', consoleChildChildTrue);
        }
        summaryArea.classList.remove('is-hidden');
      } else {
        if (debugFunction) {
          console.log('%c Hide Summary ', consoleChildChildFalse);
        }
        summaryArea.classList.add('is-hidden');
      }
      addValues();
    }

    function addValues() {
      if (debugFunction) {
        console.log('%c addValues ', consoleChildTrue);
      }
      let summaryArea = document.querySelector('.configurator_summary__list-everything');
      // Clear the summary area first and then add what we want on every change/update
      summaryArea.innerHTML = '';
      values.forEach((value) => {
        let wrapper = document.createElement('p');

        let spanTitle = document.createElement('span');
        spanTitle.classList.add('title');
        spanTitle.innerHTML = value.inputLabel;

        let spanValue = document.createElement('span');
        spanValue.classList.add('value');
        //spanValue.innerHTML = value.inputValue;

        let spanSide = '';
        let spanSide1 = '';
        if (value.inputSide === 'Binaural') {
          // Right side
          spanSide = document.createElement('span');
          spanSide.classList.add('Right');
          spanSide.innerHTML = rightSideString;
          // Left side
          spanSide1 = document.createElement('span');
          spanSide1.classList.add('Left');
          spanSide1.innerHTML = leftSideString;
        } else if (value.inputSide === 'Left') {
          spanSide = document.createElement('span');
          spanSide.classList.add(value.inputSide);
          spanSide.innerHTML = leftSideString;
        } else if (value.inputSide === 'Right') {
          spanSide = document.createElement('span');
          spanSide.classList.add(value.inputSide);
          spanSide.innerHTML = rightSideString;
        }

        let spanValueText = document.createElement('span');
        spanValueText.classList.add('text');
        spanValueText.innerHTML = value.inputValue;

        spanValue.append(spanSide, spanSide1, spanValueText);

        wrapper.append(spanTitle, spanValue);

        summaryArea.append(wrapper);
      });

      // Equalise the width of the side strings (Left and Right for example)
      if (document.querySelector('.configurator_summary__list .value .Right')) {
        rightSideWidth = document
          .querySelector('.configurator_summary__list .value .Right')
          .getBoundingClientRect().width;
      }
      if (document.querySelector('.configurator_summary__list .value .Left')) {
        leftSideWidth = document
          .querySelector('.configurator_summary__list .value .Left')
          .getBoundingClientRect().width;
      }
      if (rightSideWidth > leftSideWidth) {
        document
          .querySelectorAll(
            '.configurator_summary__list .value .Left, .configurator_summary__list .value .Right',
          )
          .forEach((item) => {
            item.setAttribute('style', 'width:' + rightSideWidth + 'px; text-align:center;');
          });
      } else if (rightSideWidth < leftSideWidth) {
        document
          .querySelectorAll(
            '.configurator_summary__list .value .Right, .configurator_summary__list .value .Left',
          )
          .forEach((item) => {
            item.setAttribute('style', 'width:' + leftSideWidth + 'px; text-align:center;');
          });
      } else if (rightSideWidth === leftSideWidth) {
        document
          .querySelectorAll(
            '.configurator_summary__list .value .Right, .configurator_summary__list .value .Left',
          )
          .forEach((item) => {
            item.setAttribute('style', 'width:' + rightSideWidth + 'px; text-align:center;');
          });
      }
    }

    // If side = binaural then one side will be disabled, we need to wait for this before running code
    // Else side = left/right we dont
    if (selectedSide === 'Binaural') {
      /* eslint-disable-next-line */
      let observer = new MutationObserver(function (mutations) {
        if (document.querySelector('.configurator__section__fields--disabled')) {
          observer.disconnect();
          pageLoad();
          interaction();
        }
      });
      observer.observe(document.querySelector('.configurator_controllers'), {
        attributes: true,
        childList: true,
        characterData: false,
        subtree: true,
      });
    } else {
      pageLoad();
      interaction();
    }

    // Some selects are updated after pageload and not being detected for the Summary
    // Start by waiting for the page to have the updated UI select menus appear .form-select__placeholder
    // Then find all of the original select menus .configuratordropdown
    // For each select get their original selectedindex value (should be 0 e.g 'Please Select')
    // Observe changes on this and compare any updated selectedindex value to original value
    // If they do not equal each other then the DOM has been updated (an option has been selected) and we need to rerun Summary builder to add updated item
    // Disconnect so we arent observing forever
    /* eslint-disable-next-line */
    let observerSelect = new MutationObserver(function (mutations) {
      if (document.querySelector('.form-select__placeholder')) {
        observerSelect.disconnect();
        let formSelectPlaceholders = document.querySelectorAll('.configuratordropdown');
        formSelectPlaceholders.forEach((formSelectPlaceholder) => {
          let originalIndex = formSelectPlaceholder.selectedIndex;
          /* eslint-disable-next-line */
          let observer = new MutationObserver(function (mutations) {
            let newIndex = formSelectPlaceholder
              .closest('.form-select')
              .querySelector('select').selectedIndex;
            if (newIndex != originalIndex) {
              pageLoad();
              interaction();
            }
            observer.disconnect();
          });
          observer.observe(formSelectPlaceholder, {
            attributes: true,
            childList: true,
            characterData: false,
            subtree: true,
          });
        });
      }
    });
    observerSelect.observe(document.querySelector('.configurator_controllers'), {
      attributes: true,
      childList: true,
      characterData: false,
      subtree: true,
    });
  }

  // ***************
  // Wireless Accessories
  // ***************
  let checkWirelessAccessories = document.querySelector(
    'accessories-carousel .number-input__field',
  );
  if (typeof checkWirelessAccessories != 'undefined' && checkWirelessAccessories != null) {
    if (debugFunction) {
      console.log('%c Wireless Accessories ', consoleParentTrue);
    }

    let value = [];

    // To show or hide summary section
    function showSummary() {
      if (value.length >= 1) {
        document
          .querySelector('.configurator_summary__list-wireless-accessories')
          .classList.remove('is-hidden');
        addHeading();
      } else {
        document
          .querySelector('.configurator_summary__list-wireless-accessories')
          .classList.add('is-hidden');
      }
    }

    function getData() {
      let wirelessAccessories = [];
      let accessories = document.querySelectorAll('accessories-carousel');
      accessories.forEach((accessory) => {
        if (accessory.querySelector('.number-input__field')) {
          wirelessAccessories.push(accessory);
        }
      });

      wirelessAccessories.forEach((slide) => {
        let accessoryItems = slide.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');

        accessoryItems.forEach((item) => {
          let accessoryItemQuantity = item.querySelector('.number-input__field')
            ? item.querySelector('.number-input__field').value
            : null;
          let accessoryItemText = item.querySelector('.configurator__accessory-title').innerText;

          // If quantity above 0
          if (accessoryItemQuantity > 0) {
            value.push([accessoryItemText.split(',').join(', '), accessoryItemQuantity]);
          }

          let itemValueHTML = '';
          for (let item of value) {
            itemValueHTML += `<span>${item[1]} x ${item[0]}</span>`;
          }
          // Write to summary
          showSummary();
          document.querySelector(
            '.configurator_summary__list-wireless-accessories .value',
          ).innerHTML = itemValueHTML;
        });
      });
    }

    function addHeading() {
      if (debugFunction) {
        console.log('%c addHeading ', consoleChildTrue);
      }
      let headings = checkWirelessAccessories
        .closest('accessories-carousel')
        .querySelectorAll('h2, h3');
      let arrayOfHeadings = Array.from(headings);
      // Find first h2 or h3 without an empty string
      let heading = arrayOfHeadings.find((el) => el.innerText.length > 1)
        ? arrayOfHeadings.find((el) => el.innerText.length > 1).innerText
        : null;
      document.querySelector('.configurator_summary__list-wireless-accessories .title').innerText =
        heading;
    }

    // Page load
    getData();

    // Interaction
    $(document).on(
      'click',
      'accessories-carousel .number-input__button--plus, accessories-carousel .number-input__button--minus',
      function () {
        // Reset array so we dont need to search for duplicates
        value = [];
        getData();
      },
    );

    $(document).on('input', 'accessories-carousel .number-input__field', function () {
      value = [];
      getData();
    });
  } else {
    if (debugFunction) {
      console.log('%c Wireless Accessories ', consoleParentFalse);
    }
  }

  // ***************
  // Chargers
  // ***************
  let checkChargerAccessories = document.querySelector(
    'accessories-carousel .configurator__accessory-checkbox',
  );
  if (typeof checkChargerAccessories != 'undefined' && checkChargerAccessories != null) {
    if (debugFunction) {
      console.log('%c Charger Accessories ', consoleParentTrue);
    }

    let value = [];

    // To show or hide summary section
    function showSummary() {
      if (value.length >= 1) {
        document
          .querySelector('.configurator_summary__list-chargers')
          .classList.remove('is-hidden');
        addHeading();
      } else {
        document.querySelector('.configurator_summary__list-chargers').classList.add('is-hidden');
      }
    }

    function getData() {
      let chargers = [];
      let accessories = document.querySelectorAll('accessories-carousel');
      accessories.forEach((accessory) => {
        if (accessory.querySelector('.configurator__accessory-checkbox')) {
          chargers.push(accessory);
        }
      });

      chargers.forEach((slide) => {
        let accessoryItems = slide.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');

        accessoryItems.forEach((item) => {
          let accessoryItemCheck = item.querySelector('input.configurator__accessory-checkbox')
            ? item.querySelector('input.configurator__accessory-checkbox').checked
            : null;
          let accessoryItemText = item.querySelector('.configurator__accessory-title').innerText;

          // If checked
          if (accessoryItemCheck) {
            value.push([accessoryItemText]);
          }

          let itemValueHTML = '';
          for (let item of value) {
            itemValueHTML += `<span>${item[0]}</span>`;
          }
          // Write to summary
          showSummary();
          document.querySelector('.configurator_summary__list-chargers .value').innerHTML =
            itemValueHTML;
        });
      });
    }

    function addHeading() {
      if (debugFunction) {
        console.log('%c addHeading ', consoleChildTrue);
      }
      let headings = checkChargerAccessories
        .closest('accessories-carousel')
        .querySelectorAll('h2, h3');
      let arrayOfHeadings = Array.from(headings);
      // Find first h2 or h3 without an empty string
      let heading = arrayOfHeadings.find((el) => el.innerText.length > 1)
        ? arrayOfHeadings.find((el) => el.innerText.length > 1).innerText
        : null;
      document.querySelector('.configurator_summary__list-chargers .title').innerText = heading;
    }

    // Page load
    getData();

    // Interaction
    $(document).on('click', 'accessories-carousel .configurator__accessory-checkbox', function () {
      // Reset array so we dont need to search for duplicates
      value = [];
      getData();
    });

    $(document).on('input', 'accessories-carousel .configurator__accessory-checkbox', function () {
      value = [];
      getData();
    });
  } else {
    if (debugFunction) {
      console.log('%c Charger Accessories ', consoleParentFalse);
    }
  }

  // ***************
  // DOM ready
  // ***************
  $(document).ready(function () {
    // ***************
    // Sanitize all inputs
    // ***************
    $('.configurator_controllers input.form-control').each(function () {
      const input = $(this);
      input.on('click', () => input.val(DOMSanitization.sanitize(input.val())));
      input.on('change', () => input.val(DOMSanitization.sanitize(input.val())));
    });
  });
}
